module.exports = __webpack_public_path__ + "static/camara-cfc61de4aae4c6b0c5fcd1e5ffb706ed.pdf";